import { render, staticRenderFns } from "./UserObject.vue?vue&type=template&id=c2e35b0c&scoped=true"
import script from "./UserObject.vue?vue&type=script&lang=js"
export * from "./UserObject.vue?vue&type=script&lang=js"
import style0 from "./UserObject.vue?vue&type=style&index=0&id=c2e35b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e35b0c",
  null
  
)

export default component.exports